"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  TPhoneFieldProps: true
};
Object.defineProperty(exports, "TPhoneFieldProps", {
  enumerable: true,
  get: function () {
    return _types.TPhoneFieldProps;
  }
});
var _PhoneField = require("./PhoneField");
Object.keys(_PhoneField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PhoneField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PhoneField[key];
    }
  });
});
var _types = require("./types");